<template>
  <div class="my-licence">
    <div class="account-card">
      <div class="account-card-header">
        <h4 class="account-card-title">处置公告管理</h4>
      </div>
      <div class="page-manage page-manage-evaluation-config">
        <query-tabs
          :query-tabs="queryTabs"
          :active.sync="activeName"
        ></query-tabs>
        <customize-form
          :form-config="formConfig"
          @on-query="onQuery"
          @on-reset="onReset"
        ></customize-form>
        <customize-table
          :table-config="tableConfig"
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :currentPage.sync="params.pageIndex"
          :key="keytable"
        >
          <template v-slot:title="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span class="cell-link" @click="onCheckBidFile(scope.row)">{{
                  scope.row.title
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:disposalCode="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span>{{
                  scope.row.disposalCode === '1' ? '竞价' : '密封报价'
                }}</span>
              </template>
            </el-table-column>
          </template>

          <template v-slot:serveScope="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span>{{
                  scope.row.serveScope == 1
                    ? '竞价服务'
                    : scope.row.serveScope == 2
                    ? '全流程服务'
                    : ''
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:buyerCompName="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span class="cell-link" @click="onShowBuyer(scope.row)">{{
                  scope.row.buyerCompName
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:operations="{ column }">
            <el-table-column v-bind="column" fixed="right">
              <template v-slot="scope">
                <span
                  @click="modify(scope.row)"
                  class="cellbutton"
                  v-if="scope.row.operateStatus == 10"
                  >确认</span
                >
                <span @click="modify(scope.row)" class="cellbutton" v-else
                  >查看</span
                >
              </template>
            </el-table-column>
          </template>
          <template v-slot:enroollAll="{ column }">
            <el-table-column v-bind="column">
              <template slot="header">
                竞买报名
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="报名成功数/报名数"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span>
                  <span>{{ scope.row.enroollAudit || 0 }}</span
                  ><span>/</span><span>{{ scope.row.enroollAll || 0 }}</span>
                </span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:enroollAll1="{ column }">
            <el-table-column v-bind="column">
              <template slot="header">
                复审
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="待审核/总报名数"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span
                  style="color:red;cursor: pointer;"
                  @click="auditFun(scope.row)"
                >
                  <span>{{ scope.row.enroollConfirmTodo || 0 }}</span
                  ><span>/</span
                  ><span>{{ scope.row.enroollAll || 0 }}</span></span
                >
              </template>
            </el-table-column>
          </template>
          <template v-slot:depositNumber="{ column }">
            <el-table-column v-bind="column">
              <template slot="header">
                交保证金
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="已支付保证金购买商数"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span>{{ scope.row.depositNumber || 0 }}</span>
              </template>
            </el-table-column>
          </template>

          <template v-slot:dealPrice="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span v-if="scope.row.dealPrice">
                  <span v-if="scope.row.bidCode == '05'"
                    >{{ scope.row.dealPrice | numberFormat(2) }}(元/{{
                      scope.row.unitName
                    }})</span
                  >
                  <span v-if="scope.row.bidCode == '10'"
                    >{{ scope.row.dealPrice | numberFormat(2) }}元</span
                  >
                </span>
                <span v-else>--</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:maxPrice="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span v-if="scope.row.maxPrice">
                  <span v-if="scope.row.bidCode == '05'"
                    >{{ scope.row.maxPrice | numberFormat(2) }}(元/{{
                      scope.row.unitName
                    }})</span
                  >
                  <span v-if="scope.row.bidCode == '10'"
                    >{{ scope.row.maxPrice | numberFormat(2) }}元</span
                  >
                </span>
                <span v-else>--</span>
              </template>
            </el-table-column>
          </template>

          <template v-slot:inspectAll="{ column }">
            <el-table-column v-bind="column">
              <template slot="header">
                申请看货
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="已反馈购买商数/预约看货购买商数"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span
                  >{{ scope.row.inspectAudit || 0 }}/{{
                    scope.row.inspectAll || 0
                  }}</span
                >
              </template>
            </el-table-column>
          </template>
          <template v-slot:surveyAudit="{ column }">
            <el-table-column v-bind="column">
              <template slot="header">
                确认书
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="已审核确认书/确认书总数"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span
                  >{{ scope.row.surveyAudit || 0 }}/{{
                    scope.row.surveyAll || 0
                  }}</span
                >
              </template>
            </el-table-column>
          </template>
          <template v-slot:dismantlePlanAudit="{ column }">
            <el-table-column v-bind="column">
              <template slot="header">
                拆除方案
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="已审核拆除方案/拆除方案总数"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
              <template
                slot-scope="scope"
                v-if="scope.row.dismantleWhether == 1"
              >
                <span class="enroollAll" v-if="activeName == 2">
                  <span>{{ scope.row.dismantlePlanAudit }}</span
                  ><span>/</span><span>{{ scope.row.dismantlePlanAll }} </span>
                </span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:dismantleWhether="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span>{{
                  scope.row.dismantleWhether == 1
                    ? '是'
                    : scope.row.dismantleWhether == 0
                    ? '否'
                    : ''
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:operateStatus="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span>{{
                  scope.row.operateStatus == 10
                    ? '待确认'
                    : scope.row.operateStatus == 11
                    ? '确认不通过'
                    : scope.row.operateStatus == 12
                    ? '确认通过'
                    : scope.row.operateStatus == 21
                    ? '报名中'
                    : scope.row.operateStatus == 22
                    ? '竞价中'
                    : scope.row.operateStatus == 31
                    ? '已成交'
                    : scope.row.operateStatus == 41
                    ? '竞价流标'
                    : scope.row.operateStatus == 42
                    ? '成交放弃'
                    : scope.row.operateStatus == 43
                    ? '已重竞'
                    : scope.row.operateStatus == 44
                    ? '已终止'
                    : ''
                }}</span>
              </template>
            </el-table-column>
          </template>

          <template v-slot:operationsbus="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <el-button
                  type="text"
                  @click="onReconnaissance(scope.row)"
                  v-if="
                    scope.row.surveyDataStatus == 1 &&
                      scope.row.surveyDataAuditWhether != 2
                  "
                  >查看踏勘资料</el-button
                >
                <el-button
                  type="text"
                  @click="onReconnaissance(scope.row, 1)"
                  v-else
                  >上传踏勘资料</el-button
                >
              </template>
            </el-table-column>
          </template>
          <template v-slot:reserveWhether="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span>{{
                  scope.row.reserveWhether == 1
                    ? scope.row.reservePrice
                    : scope.row.reserveWhether == 0
                    ? '无'
                    : ''
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:dealFailCode="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span>{{
                  scope.row.dealFailCode == 1
                    ? '不足最少购买商家数流拍'
                    : scope.row.dealFailCode == 2
                    ? '无人出价流拍'
                    : scope.row.dealFailCode == 3
                    ? '未达保留价流拍'
                    : scope.row.dealFailCode == 4
                    ? '其他'
                    : ''
                }}</span>
              </template>
            </el-table-column>
          </template>

          <template v-slot:operationsdeal="{ column }">
            <el-table-column v-bind="column" fixed="right">
              <template v-slot="scope">
                <el-button type="text" @click="onCheck(scope.row)"
                  >查看</el-button
                >
                <el-button type="text" @click="confirm(scope.row)"
                  >打印确认书</el-button
                >
                <el-button
                  type="text"
                  @click="onReconnaissance(scope.row)"
                  v-if="
                    scope.row.surveyDataStatus == 1 &&
                      scope.row.surveyDataAuditWhether != 2
                  "
                  >查看踏勘资料</el-button
                >
                <el-button
                  type="text"
                  @click="onReconnaissance(scope.row, 1)"
                  v-else
                  >上传踏勘资料</el-button
                >
                <el-button
                  type="text"
                  @click="orderDatafun(scope.row, 1)"
                  v-if="!scope.row.orderDataStatus"
                  >上传合同</el-button
                >
                <el-button type="text" @click="orderDatafun(scope.row)" v-else
                  >查看合同</el-button
                >
              </template>
            </el-table-column>
          </template>

          <template v-slot:statusCode="{ column }">
            <el-table-column v-bind="column" fixed="right">
              <template v-slot="scope">
                <span>{{
                  scope.row.operateStatus == 41
                    ? '竞价流标'
                    : scope.row.operateStatus == 42
                    ? '成交放弃'
                    : scope.row.operateStatus == 43
                    ? '已重竞'
                    : scope.row.operateStatus == 44
                    ? '已终止'
                    : ''
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:failure="{ column }">
            <el-table-column v-bind="column" fixed="right">
              <template v-slot="scope">
                <!-- <el-button
                  v-if="
                    scope.row.operateStatus != 43 &&
                      scope.row.operateStatus != 44
                  "
                  @click="weight(scope.row)"
                  type="text"
                  >重竞</el-button
                >
                <el-button
                  v-if="
                    scope.row.operateStatus != 43 &&
                      scope.row.operateStatus != 44
                  "
                  @click="termination(scope.row)"
                  type="text"
                  >终止</el-button
                > -->

                <el-button type="text" @click="onCheckBidFile(scope.row)"
                  >查看</el-button
                >
                <el-button
                  type="text"
                  @click="onReconnaissance(scope.row)"
                  v-if="
                    scope.row.surveyDataStatus == 1 &&
                      scope.row.surveyDataAuditWhether != 2
                  "
                  >查看踏勘资料</el-button
                >
                <el-button
                  type="text"
                  @click="onReconnaissance(scope.row, 1)"
                  v-else
                  >上传踏勘资料</el-button
                >
              </template>
            </el-table-column>
          </template>
        </customize-table>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogFormVisible"
      :modal-append-to-body="false"
    >
      <el-form :model="form" ref="form">
        <el-form-item
          label="重新竞价说明:"
          label-width="180"
          prop="remark"
          :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
        >
          <el-input v-model="form.remark" type="textarea" :rows="3"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="weightsubmit('form')"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="dialogtermination"
      :modal-append-to-body="false"
    >
      <el-form :model="formtermination" ref="formtermination">
        <el-form-item
          label="终止竞价说明:"
          label-width="180"
          prop="remark"
          :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
        >
          <el-input
            v-model="formtermination.remark"
            type="textarea"
            maxlength="400"
            show-word-limit
            :rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="terminationcancel">取 消</el-button>
        <el-button type="primary" @click="terminationsubmit('formtermination')"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="成交商信息"
      :visible.sync="dialogBuyer"
      :modal-append-to-body="false"
    >
      <el-form>
        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="成交商:"
              >{{
                dialogBuyerData && dialogBuyerData.compName
                  ? dialogBuyerData.compName
                  : ''
              }}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="联系人:"
              >{{
                dialogBuyerData && dialogBuyerData.contName
                  ? dialogBuyerData.contName
                  : ''
              }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="电话:"
              >{{
                dialogBuyerData && dialogBuyerData.contPhone
                  ? dialogBuyerData.contPhone
                  : ''
              }}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="手机:"
              >{{
                dialogBuyerData && dialogBuyerData.contMobile
                  ? dialogBuyerData.contMobile
                  : ''
              }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="邮箱:"
              >{{
                dialogBuyerData && dialogBuyerData.contEmail
                  ? dialogBuyerData.contEmail
                  : ''
              }}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="传真:"
              >{{
                dialogBuyerData && dialogBuyerData.contFax
                  ? dialogBuyerData.contFax
                  : ''
              }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogBuyer = false">关 闭</el-button>
      </div>
    </el-dialog>
    <ReconnaissanceDialog
      :show.sync="reconnaissanceFlag"
      :clickRow="clickRow"
      @success="onSuccess"
    />
    <OrderDataDialog
      :show.sync="orderFlag"
      :clickRow="orderClickRow"
      @success="onSuccess"
    />
  </div>
</template>
<script>
import { openNewPage, daterange } from '@/utils/constantime'
import ReconnaissanceDialog from '../../../ServiceProvider/ServiceProviderDisposalService/ServiceContractsManagement/components/ReconnaissanceDialog.vue'
import OrderDataDialog from '../../../ServiceProvider/ServiceProviderDisposalService/ServiceContractsManagement/components/OrderDataDialog.vue'
export default {
  components: {
    ReconnaissanceDialog,
    OrderDataDialog
  },
  data() {
    return {
      viewFlag: false,
      clickRow: {},
      orderFlag: false,

      orderClickRow: {},
      reconnaissanceFlag: false,
      keytable: Date.now(),
      dialogBuyer: false,
      dialogBuyerData: {},
      formtermination: {
        remark: ''
      },
      terminationsubmitid: '',
      dialogtermination: false,
      weightsubmitid: '',
      form: {
        remark: ''
      },
      dialogFormVisible: false,
      pageNum: 1,
      pageSize: 10,
      params: {
        pageIndex: 1,
        pageSize: 10
      },
      formConfig: {
        configs: {},
        operations: [
          {
            label: '查询',
            handler: 'on-query',
            type: 'primary'
          },
          {
            label: '清空',
            handler: 'on-reset',
            type: 'default'
          }
        ]
      },

      queryTabs: [
        {
          label: 1,
          name: '公告确认'
        },
        {
          label: 2,
          name: '竞买中'
        },
        {
          label: 3,
          name: '已成交'
        },
        {
          label: 4,
          name: '竞价失败'
        }
      ],
      removeV: 1,
      activeName: 1,
      //公告确认
      preorganizationFormConfig: {
        title: {
          tag: 'input',
          label: '公告标题'
        },
        code: {
          tag: 'input',
          label: '公告编号'
        },
        status: {
          tag: 'select',
          label: '状态',
          default: null,
          options: [
            { value: null, label: '全部' },
            { value: 10, label: '待确认' },
            { value: 11, label: '确认不通过' },
            { value: 12, label: '确认通过' }
          ]
        },
        serveScope: {
          tag: 'select',
          label: '服务范围',
          options: [
            { value: 1, label: '竞价服务' },
            { value: 2, label: '全流程服务' }
          ]
        },
        disposalCode: {
          tag: 'select',
          label: '处置方式',
          options: [
            { value: 1, label: '竞价' },
            { value: 2, label: '密封报价' }
          ]
        },

        enrollEndTime: {
          ...daterange,
          label: '报名截止时间'
        },
        bidStartTime: {
          ...daterange,
          label: '竞价开始日期'
        },
        entrustEndTime: {
          ...daterange,
          label: '委托截止日期'
        },
        // dismantleWhether: {
        //   tag: 'select',
        //   label: '是否拆卖一体',
        //   options: [
        //     { value: 1, label: '是' },
        //     { value: 0, label: '否' }
        //   ]
        // },
        planCode: {
          tag: 'input',
          label: '委托编号'
        }
      },
      // 竞买中
      prependingFormConfig: {
        title: {
          tag: 'input',
          label: '公告标题'
        },
        code: {
          tag: 'input',
          label: '公告编号'
        },

        status: {
          tag: 'select',
          label: '状态',
          default: null,
          options: [
            { value: null, label: '全部' },
            { value: 21, label: '报名中' },
            { value: 22, label: '竞价中' }
          ]
        },
        serveScope: {
          tag: 'select',
          label: '服务范围',
          options: [
            { value: 1, label: '竞价服务' },
            { value: 2, label: '全流程服务' }
          ]
        },
        disposalCode: {
          tag: 'select',
          label: '处置方式',
          options: [
            { value: 1, label: '竞价' },
            { value: 2, label: '密封报价' }
          ]
        },
        // dismantleWhether: {
        //   tag: 'select',
        //   label: '是否拆卖一体',
        //   options: [
        //     { value: 1, label: '是' },
        //     { value: 0, label: '否' }
        //   ]
        // },
        planCode: {
          tag: 'input',
          label: '委托编号'
        },
        bidStartTime: {
          ...daterange,
          label: '竞价开始日期'
        },
        bidEndTime: {
          ...daterange,
          label: '竞价结束日期'
        }
      },
      // 已成交
      prerevealFormConfig: {
        title: {
          tag: 'input',
          label: '公告标题'
        },
        code: {
          tag: 'input',
          label: '公告编号'
        },
        serveScope: {
          tag: 'select',
          label: '服务范围',
          options: [
            { value: 1, label: '竞价服务' },
            { value: 2, label: '全流程服务' }
          ]
        },
        disposalCode: {
          tag: 'select',
          label: '处置方式',
          options: [
            { value: 1, label: '竞价' },
            { value: 2, label: '密封报价' }
          ]
        },
        bidEndTime: {
          ...daterange,
          label: '竞价结束日期'
        },
        planCode: {
          tag: 'input',
          label: '委托编号'
        }
        // dismantleWhether: {
        //   tag: 'select',
        //   label: '是否拆卖一体',
        //   options: [
        //     { value: 1, label: '是' },
        //     { value: 0, label: '否' }
        //   ]
        // },
      },
      // 竞价失败
      prependedFormConfig: {
        title: {
          tag: 'input',
          label: '公告标题'
        },
        code: {
          tag: 'input',
          label: '公告编号'
        },
        status: {
          tag: 'select',
          label: '状态',
          default: null,
          options: [
            { value: null, label: '全部' },
            { value: 41, label: '竞价流标' },
            { value: 42, label: '成交放弃' },
            { value: 43, label: '已重竞' },
            { value: 44, label: '已终止' }
          ]
        },
        serveScope: {
          tag: 'select',
          label: '服务范围',
          options: [
            { value: 1, label: '竞价服务' },
            { value: 2, label: '全流程服务' }
          ]
        },
        disposalCode: {
          tag: 'select',
          label: '处置方式',
          options: [
            { value: 1, label: '竞价' },
            { value: 2, label: '密封报价' }
          ]
        },
        dealFailCode: {
          tag: 'select',
          label: '竞价失败原因',
          default: null,
          options: [
            { value: null, label: '全部' },
            { value: 1, label: '不足最少购买商家数流拍' },
            { value: 2, label: '无人出价流拍' },
            { value: 3, label: '未达保留价流拍' },
            { value: 4, label: '其他' }
          ]
        },
        // compName: {
        //   tag: 'input',
        //   label: '委托企业'
        // },

        // dismantleWhether: {
        //   tag: 'select',
        //   label: '是否拆卖一体',
        //   options: [
        //     { value: 1, label: '是' },
        //     { value: 0, label: '否' }
        //   ]
        // },

        bidEndTime: {
          ...daterange,
          label: '竞价结束日期'
        },
        entrustEndTime: {
          ...daterange,
          label: '委托结束日期'
        },
        planCode: {
          tag: 'input',
          label: '委托编号'
        }
      },
      // 默认表格配置
      tableConfig: {
        isPagination: true,
        columns: [],
        data: [],
        total: 0
      },
      // 未发布
      preorganizationTableColumns: [
        {
          label: '序号',
          type: 'index',
          width: '50px',
          align: 'center',
          key: 1
        },
        {
          prop: 'code',
          'show-overflow-tooltip': true,
          label: '公告编号',
          align: 'center',
          width: '150px',
          key: 2
        },
        {
          slot: 'title',
          prop: 'title',
          label: '公告标题',
          width: '150px',
          'show-overflow-tooltip': true,
          key: 3
        },
        {
          prop: 'planCode',
          label: '委托编号',
          align: 'center',
          width: '150px',
          'show-overflow-tooltip': true,
          key: 8
        },
        {
          slot: 'disposalCode',
          prop: 'disposalCode',
          'show-overflow-tooltip': true,
          label: '处置方式',
          align: 'center',
          key: 4
        },
        // {
        //   slot: 'dismantleWhether',
        //   prop: 'dismantleWhether',
        //   'show-overflow-tooltip': true,
        //   label: '是否拆卖一体',
        //   align: 'center',
        //   key: 12
        // },
        {
          slot: 'serveScope',
          prop: 'serveScope',
          'show-overflow-tooltip': true,
          label: '服务范围',
          align: 'center',
          width: '120px',
          key: 5
        },

        {
          prop: 'enrollEndTime',
          label: '报名截止时间',
          align: 'center',
          width: '150px',
          'show-overflow-tooltip': true,
          key: 6
        },
        {
          prop: 'bidStartTime',
          label: '竞价开始时间',
          align: 'center',
          width: '150px',
          key: 7,
          'show-overflow-tooltip': true
        },

        {
          prop: 'entrustEndTime',
          label: '委托结束时间',
          align: 'center',
          width: '150px',
          'show-overflow-tooltip': true,
          key: 9
        },
        {
          slot: 'operateStatus',
          prop: 'operateStatus',
          label: '状态',
          align: 'center',
          width: '100px',
          key: 10
        },
        {
          slot: 'operations',
          prop: 'operations',
          label: '操作',
          width: '120px',
          align: 'center',
          key: 11
        }
      ],
      // 竞买中
      prependingTableColumns: [
        {
          label: '序号',
          type: 'index',
          width: '50px',
          align: 'center',
          key: 20
        },
        {
          prop: 'code',
          label: '公告编号',
          width: '150px',
          'show-overflow-tooltip': true,
          key: 21
        },
        {
          slot: 'title',
          prop: 'title',
          label: '公告标题',
          width: '150px',
          'show-overflow-tooltip': true,
          key: 22
        },
        {
          prop: 'planCode',
          label: '委托编号',
          width: '150px',
          'show-overflow-tooltip': true,
          key: 31
        },
        {
          slot: 'disposalCode',
          prop: 'disposalCode',
          'show-overflow-tooltip': true,
          label: '处置方式',
          align: 'center',
          key: 23
        },
        // {
        //   slot: 'dismantleWhether',
        //   prop: 'dismantleWhether',
        //   'show-overflow-tooltip': true,
        //   label: '是否拆卖一体',
        //   align: 'center',
        //   key: 35
        // },
        {
          prop: 'serveScope',
          slot: 'serveScope',
          label: '服务范围',
          width: '120px',
          align: 'center',
          'show-overflow-tooltip': true,
          key: 24
        },

        {
          prop: 'bidStartTime',
          label: '竞价开始时间',
          align: 'center',
          width: '150px',
          'show-overflow-tooltip': true,
          key: 26
        },
        {
          prop: 'bidEndTime',
          label: '竞价结束时间',
          align: 'center',
          width: '150px',
          'show-overflow-tooltip': true,
          key: 25
        },
        {
          prop: 'enroollAll',
          slot: 'enroollAll',
          label: '竞买报名',
          align: 'center',
          width: '100px',
          key: 27
        },
        {
          prop: 'enroollAll1',
          slot: 'enroollAll1',
          label: '复审',
          align: 'center',
          width: '100px',
          key: 37
        },
        {
          slot: 'depositNumber',
          prop: 'depositNumber',
          label: '交保证金',
          align: 'center',
          width: '100px',
          key: 28
        },
        {
          prop: 'inspectAll',
          slot: 'inspectAll',
          label: '申请看货',
          align: 'center',
          width: '100px',
          key: 29
        },
        {
          prop: 'surveyAudit',
          slot: 'surveyAudit',
          label: '确认书',
          align: 'center',
          width: '100px',
          key: 30
        },

        // {
        //   prop: 'dismantlePlanAudit',
        //   slot: 'dismantlePlanAudit',
        //   label: '拆除方案',
        //   align: 'center',
        //   width: '100px',
        //   key: 36
        // },

        {
          prop: 'quoteNumber',
          label: '报价数',
          align: 'center',
          width: '100px',
          'show-overflow-tooltip': true,
          key: 32
        },
        {
          slot: 'operateStatus',
          prop: 'operateStatus',
          label: '状态',
          align: 'center',

          key: 33
        },
        {
          slot: 'operationsbus',
          prop: 'operationsbus',
          label: '操作',
          width: '150px',
          align: 'center',
          fixed: 'right',
          key: 34
        }
      ],
      //已成交
      prerevealTableColumns: [
        {
          label: '序号',
          type: 'index',
          width: '50px',
          align: 'center',
          key: 41
        },

        {
          prop: 'code',
          label: '公告编号',
          width: '150px',
          'show-overflow-tooltip': true,
          key: 43
        },
        {
          slot: 'title',
          prop: 'title',
          label: '公告标题',
          width: '150px',
          'show-overflow-tooltip': true,
          key: 44
        },
        {
          prop: 'planCode',
          label: '委托编号',
          align: 'center',
          width: '150px',
          'show-overflow-tooltip': true,
          key: 52
        },
        {
          slot: 'disposalCode',
          prop: 'disposalCode',
          'show-overflow-tooltip': true,
          label: '处置方式',
          align: 'center',
          key: 45
        },
        // {
        //   slot: 'dismantleWhether',
        //   prop: 'dismantleWhether',
        //   'show-overflow-tooltip': true,
        //   label: '是否拆卖一体',
        //   align: 'center',
        //   key: 51
        // },
        {
          prop: 'serveScope',
          slot: 'serveScope',
          label: '服务范围',
          width: '120px',
          align: 'center',
          'show-overflow-tooltip': true,
          key: 46
        },
        {
          prop: 'bidEndTime',
          label: '竞价结束时间',
          align: 'center',
          width: '150px',
          key: 47
        },
        {
          slot: 'dealPrice',
          prop: 'dealPrice',
          label: '成交价',
          align: 'center',
          width: '120px',
          'show-overflow-tooltip': true,
          key: 49
        },
        {
          key: 48,
          prop: 'buyerCompName',

          label: '买受人',
          align: 'center',
          width: '120px',
          'show-overflow-tooltip': true
        },

        {
          prop: 'operationsdeal',
          slot: 'operationsdeal',
          label: '操作',
          width: '150px',
          align: 'center',
          key: 50
        }
      ],
      // 竞价失败
      prependedTableColumns: [
        {
          label: '序号',
          type: 'index',
          width: '50px',
          align: 'center',
          key: 60
        },
        {
          prop: 'code',
          label: '公告编号',
          width: '150px',
          'show-overflow-tooltip': true,
          key: 62
        },
        {
          slot: 'title',
          prop: 'title',
          label: '公告标题',
          width: '150px',
          'show-overflow-tooltip': true,
          key: 61
        },
        {
          prop: 'planCode',
          label: '委托编号',
          align: 'center',
          width: '150px',
          'show-overflow-tooltip': true,
          key: 68
        },
        {
          slot: 'disposalCode',
          prop: 'disposalCode',
          'show-overflow-tooltip': true,
          label: '处置方式',
          align: 'center',
          key: 63
        },
        // {
        //   slot: 'dismantleWhether',
        //   prop: 'dismantleWhether',
        //   'show-overflow-tooltip': true,
        //   label: '是否拆卖一体',
        //   align: 'center',
        //   key: 73
        // },
        {
          slot: 'serveScope',
          prop: 'serveScope',
          'show-overflow-tooltip': true,
          label: '服务范围',
          width: '100px',
          align: 'center',
          key: 64
        },
        {
          prop: 'bidEndTime',
          label: '竞价结束时间',
          align: 'center',
          width: '150px',
          key: 70
        },
        {
          prop: 'entrustEndTime',
          label: '委托结束时间',
          align: 'center',
          width: '150px',
          key: 76
        },
        {
          slot: 'enroollAll',
          prop: 'enroollAll',
          label: '竞买报名',
          align: 'center',
          width: '100px',
          key: 65
        },
        // {
        //   prop: 'depositNumber',
        //   label: '交保证金',
        //   align: 'center',
        //   width: '100px',
        //   key: 66
        // },
        {
          slot: 'inspectAll',
          prop: 'inspectAll',
          label: '申请看货',
          align: 'center',
          width: '100px',
          key: 67
        },
        {
          prop: 'reserveWhether',
          slot: 'reserveWhether',
          label: '保留价(元)',
          align: 'center',
          width: '100px',
          key: 75
        },
        {
          prop: 'maxPrice',
          slot: 'maxPrice',
          label: '最高价',
          align: 'center',
          width: '120px',
          'show-overflow-tooltip': true,
          key: 74
        },

        {
          prop: 'dealFailCode',
          slot: 'dealFailCode',
          label: '失败原因',
          align: 'center',
          width: '130px',
          'show-overflow-tooltip': true,
          key: 77
        },

        {
          prop: 'statusCode',
          slot: 'statusCode',
          width: '100px',
          label: '状态',
          align: 'center',
          key: 71
        },
        {
          prop: 'failure',
          slot: 'failure',
          label: '操作',
          width: '170px',
          align: 'center',
          key: 72
        }
      ]
    }
  },
  watch: {
    activeName: {
      handler: function(val) {
        this.activeName = val
        this.params = {
          pageIndex: this.pageNum,
          pageSize: this.pageSize
        }

        this.onChoose(val)
      },
      immediate: true
    }
  },
  created() {
    // this.sellerAuditGet()
  },
  methods: {
    onCheckBidFile(o) {
      let query = {
        id: o.id,
        type: 'check'
      }
      openNewPage('ServiceCompileMaterialCheck', query)
    },
    async onShowBuyer(o) {
      let data = await this.$api.enrooll.getEnroollByComp({
        noticeId: o.id,
        buyerCompCode: o.buyerCompCode
      })

      this.dialogBuyer = true
      this.dialogBuyerData = data
    },
    onChoose(val) {
      if (val === 1) {
        this.planListTodo()
      } else if (val === 2) {
        this.listTodo()
      } else if (val === 3) {
        this.listToOpen()
      } else if (val === 4) {
        this.listHas()
      }
    },

    async planListTodo() {
      this.tableConfig.data = []
      // this.tableConfig.total = 0
      this.formConfig.configs = this.preorganizationFormConfig
      this.tableConfig.columns = this.preorganizationTableColumns
      let obj = {
        ...this.params,
        tag: 1
      }
      let data = await this.$api.materialdisposal.getEntrustnoticeList(obj)
      this.tableConfig.data = data.data

      this.tableConfig.total = data.total
    },
    async listTodo() {
      this.tableConfig.data = []
      // this.tableConfig.total = 0
      this.formConfig.configs = this.prependingFormConfig
      this.tableConfig.columns = this.prependingTableColumns
      let obj = {
        ...this.params,
        tag: 2
      }
      let data = await this.$api.materialdisposal.getEntrustnoticeList(obj)
      this.tableConfig.data = data.data

      this.tableConfig.total = data.total
    },
    async listToOpen() {
      this.tableConfig.data = []
      // this.tableConfig.total = 0
      this.formConfig.configs = this.prerevealFormConfig
      this.tableConfig.columns = this.prerevealTableColumns
      let obj = {
        ...this.params,
        tag: 3
      }
      let data = await this.$api.materialdisposal.getEntrustnoticeList(obj)
      this.tableConfig.data = data.data

      this.tableConfig.total = data.total
    },

    async listHas() {
      this.tableConfig.data = []
      // this.tableConfig.total = 0
      this.formConfig.configs = this.prependedFormConfig
      this.tableConfig.columns = this.prependedTableColumns
      // this.prependingFormConfig.scheduleCode.options = this.convertSchedule(
      //   data
      // )
      let obj = {
        ...this.params,
        tag: 4
      }
      let data = await this.$api.materialdisposal.getEntrustnoticeList(obj)
      this.tableConfig.data = data.data
      this.tableConfig.total = data.total
    },
    remove(val) {
      this.removeV = val
    },
    onQuery(val) {
      this.params = {
        ...val,
        enrollEndTimeStart:
          val.enrollEndTime && val.enrollEndTime.length != 0
            ? val.enrollEndTime[0]
            : null,
        enrollEndTimeEnd:
          val.enrollEndTime && val.enrollEndTime.length != 0
            ? val.enrollEndTime[1]
            : null,
        bidStartTimeStart:
          val.bidStartTime && val.bidStartTime.length != 0
            ? val.bidStartTime[0]
            : null,
        bidStartTimeEnd:
          val.bidStartTime && val.bidStartTime.length != 0
            ? val.bidStartTime[1]
            : null,
        entrustEndTimeStart:
          val.entrustEndTime && val.entrustEndTime.length != 0
            ? val.entrustEndTime[0]
            : null,
        entrustEndTimeEnd:
          val.entrustEndTime && val.entrustEndTime.length != 0
            ? val.entrustEndTime[1]
            : null,
        bidEndTimeEnd:
          val.bidEndTime && val.bidEndTime.length != 0
            ? val.bidEndTime[1]
            : null,
        bidEndTimeStart:
          val.bidEndTime && val.bidEndTime.length != 0
            ? val.bidEndTime[0]
            : null,
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
        bidStartTime: null,
        enrollEndTime: null,
        bidEndTime: null,
        entrustEndTime: null
      }
      this.onChoose(this.activeName)
    },
    onReset() {
      this.params = {
        pageIndex: this.pageNum,
        pageSize: this.pageSize
      }
      this.onChoose(this.activeName)
    },
    onRepeat(row) {
      let query = {
        id: row.id
      }
      this.$router.push({ name: 'CommissionAnnouncementRepeatConfim', query })
    },
    monitoring(o) {
      let query = {
        id: o.id
      }
      openNewPage('monitoring', query)
    },
    auditFun(row) {
      let query = {
        id: row.id,
        formType: 'disposal'
      }
      this.$router.push({ name: 'CommissionAnnouncementRepeatConfim', query })
    },

    feedback(o) {
      let query = {
        id: o.id
      }
      this.$router.push({ name: 'ServiceApplicationInspection', query })
    },
    onReviewConfirm(o) {
      let query = {
        id: o.id
      }
      this.$router.push({ name: 'ServiceReviewConfirmation', query })
    },
    onAudit(o) {
      let query = {
        id: o.id
      }
      this.$router.push({ name: 'ServiceQualificationAudit', query })
      // this.$router.push({ name: 'ServiceApplicationInspection', query })
      // this.$router.push({ name: 'ServiceReviewConfirmation', query })
    },
    onDisassemble(o) {
      let query = {
        id: o.id
      }
      this.$router.push({ name: 'ServiceDisassemble', query })
    },
    async confirm(o) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let res = await this.$api.notice.printResult(o.id)
      loading.close()
      let blob = new Blob([res], { type: 'application/pdf' })
      let fileName = '成交结果确认书'
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = fileName
      link.click()
      link.remove()
      URL.revokeObjectURL(link.href)
    },
    onCurrentChange(val) {
      this.params = {
        ...this.params,
        pageIndex: val,
        pageSize: 10
      }
      this.onChoose(this.activeName)
    },
    onSizeChange(val) {
      this.params = {
        pageIndex: 1,
        pageSize: val
      }
      this.onChoose(this.activeName)
    },
    async businessend() {
      let obj = {
        noticeId: this.weightsubmitid,
        remark: this.formtermination.remark
      }
      let data = await this.$api.serviceProvider.businessend(obj)
      if (data) {
        this.$message.success('提交成功')
        this.formtermination.remark = ''
        this.dialogtermination = false
        this.onChoose(this.activeName)
      }
    },
    onCheck(o) {
      let query = {
        id: o.id
      }
      openNewPage('monitoring', query)
    },
    async orderDatafun(row, type) {
      if (type) {
        let data = await this.$api.serviceProvider.checkOrderData(row.id)
        if (data.operateFlag) {
          this.orderFlag = true
          this.orderClickRow = row
        } else {
          this.$message.error(data.message)
        }
      } else {
        this.orderFlag = true
        this.orderClickRow = row
      }
    },
    async reset() {
      let obj = {
        noticeId: this.weightsubmitid,
        remark: this.form.remark
      }
      let data = await this.$api.serviceProvider.reset(obj)
      if (data) {
        this.$message.success('提交成功')
        this.dialogFormVisible = false
        this.form.remark = ''
        this.onChoose(this.activeName)
      }
    },
    weight(o) {
      this.dialogFormVisible = true
      this.weightsubmitid = o.id
    },
    termination(o) {
      this.dialogtermination = true
      this.terminationsubmitid = o.id
    },
    terminationsubmit(formtermination) {
      this.$refs[formtermination].validate(valid => {
        if (valid) {
          this.businessend()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    async onReconnaissance(row, type) {
      if (type) {
        let data = await this.$api.serviceProvider.checkSurveyData(row.id)
        if (data.operateFlag) {
          this.reconnaissanceFlag = true
          this.clickRow = row
        } else {
          this.$message.error(data.message)
        }
      } else {
        this.reconnaissanceFlag = true
        this.clickRow = row
      }
    },
    async noticeBack(o) {
      let data = await this.$api.materialdisposal.noticeBack(o.id)
      if (data) {
        this.$message({
          type: 'success',
          message: '撤销成功!'
        })
      }
      this.onChoose(this.activeName)
    },
    undo(o) {
      this.$confirm('确定撤销本条公告？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.noticeBack(o)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消撤销'
          })
        })
    },
    terminationcancel() {
      this.formtermination.remark = ''
      this.dialogtermination = false
    },
    onSuccess(val) {
      if (val) {
        this.onChoose(this.activeName)
      }
    },
    cancel() {
      this.form.remark = ''
      this.dialogFormVisible = false
    },

    weightsubmit(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.reset()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //修改
    modify(o) {
      console.log(o)
      let query = {
        id: o.id,
        type: o.operateStatus == 10 ? 'confirm' : ''
      }
      if (o.operateStatus == 10) {
        this.$router.push({ name: 'CommissionAnnouncementDetail', query })
      } else {
        this.$openNewPage('CommissionAnnouncementDetail', query)
      }
    },
    async noticeDelete(o) {
      let obj = {
        id: o.id
      }
      let data = await this.$api.materialdisposal.noticeDelete(obj)
      console.log(data)
      if (data) {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }
      this.onChoose(this.activeName)
    }
  }
}
</script>
<style lang="less" scoped>
.text {
  margin-right: 8px;
}
.enroollAll {
  color: red;
  cursor: pointer;
}
// span{
// pointer-events:none;
// color: lightslategrey;
// }
.distext {
  margin-right: 8px;
  pointer-events: none;
  color: lightslategrey;
}
.link {
  color: cornflowerblue;
  cursor: pointer;
}
p {
  margin-bottom: 10px;
}
</style>
